import { message, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { AiFillCopy } from 'react-icons/ai';

import ActionLink from '../ActionLink';
import * as Styled from './CopyBlockchainAddressActionLink.styles';

type Props = {
  blockchainAddress: string;
};

const CopyBlockchainAddressActionLink = ({ blockchainAddress }: Props) => {
  const { t } = useTranslation();

  const copyBlockchainAddress = (address: string) => {
    navigator.clipboard.writeText(address);
    message.success(t('success.copyBlockchainAddress'));
  };

  return (
    <Tooltip placement="top" title={t('document.copyBlockchainAddress')}>
      <ActionLink onClick={() => copyBlockchainAddress(blockchainAddress)}>
        {`${blockchainAddress.slice(0, 4)}...${blockchainAddress.slice(-4)}`}
        <Styled.Icon>
          <AiFillCopy />
        </Styled.Icon>
      </ActionLink>
    </Tooltip>
  );
};

export default CopyBlockchainAddressActionLink;
